// app/src/aws-exports.js
const myAuthority = process.env.REACT_APP_AUTHORITY
const myScope = process.env.REACT_APP_COGNITO_SCOPE

const userPoolId = process.env.REACT_APP_COGNITO_USER_POOL_ID
const myClientId = process.env.REACT_APP_COGNITO_CLIENT_ID
const myCognitoDomain = process.env.REACT_APP_COGNITO_DOMAIN
const myRedirectSignIn = process.env.REACT_APP_REDIRECT_SIGNIN
const myRedirectSignOut = process.env.REACT_APP_REDIRECT_SIGNOUT

const awsExports = {
  // AWS Region Configuration
  aws_project_region: 'us-east-1',
  aws_cognito_region: 'us-east-1',
  
  // Cognito User Pool Configuration
  aws_user_pools_id: userPoolId,
  aws_user_pools_web_client_id: myClientId,
  
  // Optional: Identity Pool (only if you're using it)
  // aws_cognito_identity_pool_id: 'us-east-1:xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx',
  
  // User Pool Configuration
  aws_cognito_signup_attributes: ['EMAIL'], // Attributes required for signup
  aws_cognito_social_providers: [], // Add ['GOOGLE', 'FACEBOOK', 'AMAZON'] if using social providers
  aws_cognito_username_attributes: ['EMAIL'], // Allow email as username
  aws_cognito_verification_mechanisms: ['EMAIL'], // Email verification
  
  // Hosted UI OAuth Configuration
  oauth: {
    // Your Cognito Domain (without https://)
    //domain: 'your-domain.auth.us-east-1.amazoncognito.com', // Replace with your actual domain
    domain: myCognitoDomain,
    
    // OAuth Scopes
    //scope: ['email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
    scope: ['email', 'openid', 'phone'], // Adjust scopes as needed'],
    
    // Redirect URIs (must match what's configured in your App Client)
    redirectSignIn: myRedirectSignIn, // For development
    redirectSignOut: myRedirectSignOut, // For development
    
    // OAuth Response Type
    responseType: 'code', // Use authorization code flow
    
    // Optional: Advanced OAuth settings
    options: {
      // Enable refresh token rotation
      AdvancedSecurityDataCollection: false,
    }
  },
  
  // Optional: Configure MFA if enabled
  // aws_cognito_mfa_configuration: 'OPTIONAL', // or 'ON' if required
  // aws_cognito_mfa_types: ['SMS'], // or ['TOTP'] for authenticator apps
  
  // Optional: Password policy (if you want to enforce client-side)
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: [
      'REQUIRES_LOWERCASE',
      'REQUIRES_UPPERCASE',
      'REQUIRES_NUMBERS',
      'REQUIRES_SYMBOLS'
    ]
  }
};

export default awsExports;